<template>
    <div class="form-group checkbox-form-group clearfix no-focus" :class="[colClass, customErrorClass]">
        <fieldset role="group" :aria-labelledby="`${vmId} ${errorIds}`">
            <legend :class="{ dfRequired: settings.required, dfOptional: !settings.required, 'sr-only': effectiveLabelText != effectiveLabel }">
                <span :id="vmId">{{ effectiveLabelText }}</span>
                <HelpIcon :text="settings.helpText" v-if="!isViewOnly" />
                <button class="passthrough icon mr-1" type="button" v-if="showAdminEditControls" @click.prevent="toggleAdminEdit" :class="isAdminEditing ? ['icon-close'] : ['icon-edit']">
                    <span class="sr-only">{{ isAdminEditing ? "Stop Edit" : "Edit" }}</span>
                </button>
            </legend>
            <!--
            </label>I: <input type="checkbox" v-model="useIndeterminate"></label>
            <pre>HV: {{ JSON.stringify(hasValue) }}
EC: {{ JSON.stringify(effectiveCheckboxValue) }}
TV: {{ JSON.stringify(tempValue) }}
V: {{ JSON.stringify(value) }}
EV: {{ JSON.stringify(effectiveValue) }}
DV: {{ JSON.stringify(defaultValue) }}</pre>
            -->
            <div v-if="settings.layout == 3">
                <div>
                    <div class="col-sm-12 clearfix" v-for="[index, item] in (children || []).entries()" :style="childStyle(item)">
                        <!-- data-bind="visible: $data.isCheckGroupItem, if: $data.isCheckGroupItem" -->
                        <div class="checkbox-withchild">
                            <!-- :class="[item.settings.layout == 2 ? 'radio' : 'checkbox']"> -->
                            <label class="form-check-label" :for="isViewOnly ? undefined : vmId + '_Id_' + index">
                                <template v-if="item.definition.settings.layout == 2">
                                    <input ref="checkRef" type="radio" v-model="effectiveCheckboxValue" :value="item.definition.settings.effectiveValue" class="radio" :disabled="isViewOnly" :indeterminate.prop="indeterminateValue(item.definition.settings.effectiveValue)" :id="vmId + '_Id_' + index" />
                                </template>
                                <template v-else>
                                    <input ref="checkRef" type="checkbox" v-model="effectiveCheckboxValue" :value="item.definition.settings.effectiveValue" class="checkbox" :disabled="isViewOnly" :indeterminate.prop="indeterminateValue(item.definition.settings.effectiveValue)" :id="vmId + '_Id_' + index" />
                                </template>
                                {{ item.definition.settings.label }}
                            </label>
                        </div>
                        <div id="children" class="col-sm-11 col-sm-offset-1" v-show="effectiveValue.indexOf(item.definition.settings.effectiveValue) >= 0">
                            <ChildrenList :children-ids="item.children" :view-only="isViewOnly"></ChildrenList>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="settings.layout != 3">
                <!--TODO real stacked int -->
                <div v-if="settings.layout == 1">
                    <div class="checkbox" v-for="[index, item] in (effectiveItems || []).entries()">
                        <!--
                        <label class="form-check-label" @click.prevent="toggle(item.value, $event);">
                            <input type="checkbox" @click.prevent :disabled="isViewOnly" :checked.prop="(value == null || value.length == 0) ? defaultValue != null && defaultValue.includes(item.value) : value.includes(item.value)" />
                        -->
                        <label class="form-check-label" :for="isViewOnly ? undefined : vmId + '_Id_' + index">
                            <input ref="checkRef" type="checkbox" v-model="effectiveCheckboxValue" :value="item.value" :disabled="isViewOnly" :indeterminate.prop="indeterminateValue(item.value)" :id="vmId + '_Id_' + index" />
                            {{ item.label }}
                        </label>
                    </div>
                </div>
                <div v-if="settings.layout != 1">
                    <label class="checkbox-inline form-check-label" v-for="[index, item] in (effectiveItems || []).entries()" :for="isViewOnly ? undefined : vmId + '_Id_' + index">
                        <!--
                        {{ defaultValue }} - {{ effectiveCheckboxValue }} - {{ item.value }} -- {{ effectiveValue }}
                        -->
                        <input ref="checkRef" type="checkbox" v-model="effectiveCheckboxValue" :value="item.value" :disabled="isViewOnly" :indeterminate.prop="indeterminateValue(item.value)" :id="vmId + '_Id_' + index" />
                        {{ item.label }}
                    </label>
                </div>
            </div>

            <ErrorList :data="data" :id="errorId" />
            <Comments :data="data" />
            <AdminSettingsDifferences :data="data" />
        </fieldset>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref, watch, computed, nextTick } from "vue";
import arrayEqual from "@/lib/arrayEquals";
import { map, tap } from "rxjs/operators";
import { props, Props, components, setup } from "./BaseDefMixin.3";
import type { CheckGroupSettings } from "@cs-ts/check-group-settings";
import type CheckGroupDef from "../elements/CheckGroupDef";
import { useObservable } from "@vueuse/rxjs";
import { ObservableReturnType } from "@/lib/observableHelpers";
export default defineComponent({
    components: {
        ...components,
        //DatePicker,
    },
    props: props,
    //@ts-ignore
    setup(props: Props<CheckGroupDef, CheckGroupSettings>) {
        const base = setup<CheckGroupDef, CheckGroupSettings>(props);

        const checkRef = ref([] as HTMLInputElement[]);
        base.focus = () => {
            if (checkRef.value.length > 0) {
                checkRef.value[0].focus();
            }
        };

        const useIndeterminate = ref(false);
        const tempValue = ref([] as string[]);

        const effectiveCheckboxValue = computed({
            get() {
                return useIndeterminate.value || base.isViewOnly.value ? (base.value.value as unknown as string[]) : tempValue.value;
            },
            set(value) {
                if (useIndeterminate.value) {
                    base.value.value = value;
                    tempValue.value = value!;
                } else {
                    if (base.value.value?.length == 0 && value?.length == 0) {
                        //console.log(`A - Clear value`);
                        base.value.value = [];
                    }
                    //console.log(`A - Set temp value to ${JSON.stringify(value ?? [])}`);
                    tempValue.value = value!;
                }
            },
        });
        const effectiveValue = computed(() => {
            return effectiveValueM();
        });

        const checkForInvalidValues = () => {
            nextTick(() => {
                nextTick(() => {
                    const clientValidateRules = props.data.clientValidateRules$?.getValue() || {};
                    const findEffectiveItems = (value: string) => ((effectiveItems.value ?? []) as effectiveItemsType).find(item => item.value == value);
                    if ("data-val-serveronlyerror-values" in clientValidateRules) {
                        clientValidateRules["data-val-serveronlyerror-values"] = clientValidateRules["data-val-serveronlyerror-values"]
                            .split("`")
                            .filter((errorValue: string) => !findEffectiveItems(errorValue))
                            .join("`");
                        props.data.clientValidateRules$.next(clientValidateRules);
                    }
                    tempValue.value = tempValue.value.filter(value => findEffectiveItems(value));
                });
            });
        };
        const effectiveItems = useObservable(props.data.effectiveItems$().pipe(tap(() => checkForInvalidValues())));
        type effectiveItemsType = ObservableReturnType<ReturnType<typeof props.data.effectiveItems$>>;
        const defaultValue = useObservable(props.data.defaultValue$().pipe(map(i => i.filter(j => j != null) as string[])));
        const hasValue = useObservable(props.data.hasValue$());
        const effectiveLabel = useObservable(props.data.effectiveLabel$());
        const effectiveLabelText = useObservable(props.data.effectiveLabelText$());

        const effectiveValueM = () => {
            //console.log(`ZZ - Effective Value is ${JSON.stringify(hasValue.value)} ? ${JSON.stringify(value.value ?? [])} : ${JSON.stringify(defaultValue.value ?? [])}`);
            return (hasValue.value ? (base.value.value as string[] | null) : (defaultValue.value as string[])) ?? [];
        };
        const indeterminateValue = (itemValue: string) => {
            if (useIndeterminate.value && !hasValue.value) {
                return (base.value.value == null || base.value.value.length == 0) && defaultValue.value != null && defaultValue.value.includes(itemValue);
            } else {
                return false;
            }
        };
        //toggle(val, event) {
        //    event.preventDefault();
        //    $nextTick.value(() => {
        //    if (value.value.includes(val)) {
        //        for(let i = value.value.length -1; i >= 0; i--) {
        //            if (value.value[i] == val) {
        //                value.value.splice(i, 1);
        //            }
        //        }
        //    } else {
        //        value.value.push(val);
        //    }
        //    });
        //},
        //const saveAdminEdit = async () => {
        //    throw new Error();
        //    //await $store.value.dispatch("page/invokeForm", { type: "AdminEdit", target: /* TODO not unique - ForEach */ props.data.id, data: value.value });
        //    //isAdminEditing.value = false;
        //};

        watch(
            () => useIndeterminate.value,
            newValue => {
                if (base.value.value?.length == 0 && newValue) {
                    tempValue.value = effectiveValueM();
                }
            },
        );
        watch(
            () => tempValue.value,
            (newValue, _) => {
                nextTick(() => {
                    if (!arrayEqual(newValue, effectiveValue.value)) {
                        if (!hasValue.value && (newValue.length == 0 || arrayEqual(newValue, defaultValue.value ?? []))) {
                            //console.log(`C - Set temp value to ${JSON.stringify(defaultValue.value ?? [])}`);
                            tempValue.value = defaultValue.value ?? [];
                            if (useIndeterminate.value) return;
                            //value.value = [];
                        } else {
                            //console.log(`D - Set value to ${JSON.stringify(tempValue.value ?? [])}`);
                            if (useIndeterminate.value) return;
                            base.value.value = tempValue.value ?? [];
                        }
                    } else {
                        //console.log(`F - Skip temp value to ${JSON.stringify(newValue)} - ${JSON.stringify(effectiveValue.value)}`);
                    }
                });
            },
        );

        nextTick(() => {
            //console.log(`A - Set temp value to ${JSON.stringify(effectiveValueM.value())}`);
            tempValue.value = effectiveValueM();
            watch(
                () => defaultValue.value,
                (newValue, oldValue) => {
                    nextTick(() => {
                        if (!hasValue.value && arrayEqual(oldValue ?? [], tempValue.value ?? [])) {
                            //console.log(`B - Set temp value to ${JSON.stringify(newValue ?? [])}`);
                            tempValue.value = newValue ?? [];
                        } else {
                            if (base.isViewOnly.value) {
                                base.value.value = newValue ?? [];
                            }
                            //console.log(`E - Skip temp value to ${JSON.stringify(newValue)} - ${JSON.stringify(oldValue)} - ${JSON.stringify(tempValue.value)}`);
                        }
                    });
                },
                { deep: true },
            );
        });

        return {
            effectiveCheckboxValue,
            effectiveItems,
            effectiveLabel,
            effectiveLabelText,
            effectiveValue,

            checkRef,

            indeterminateValue,

            ...base.expose,
        };
    },
});
</script>
